<template>
  <iframe
    :src="_url"
    class="iframe-page"
    :ref="widgetId"
    frameborder="0"
  ></iframe>
</template>

<script>
/*
   * 页面嵌入
   * url 页面地址
   * */
export default {
  name: 'iframe-page',
  props: {
    widgetId: {
      // 柱状图数据请求id
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: 0
    }
  },
  computed:{
    _url(){
      if(this.url.includes('?')) return `${this.url}&_t=${new Date().getTime()}`
      else return `${this.url}?_t=${new Date().getTime()}`
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.loopRefreshWidget()
  },
  methods: {
    // 轮巡请求
    loopRefreshWidget () {
      if (this.refreshPeriod !== 0) {
        setInterval(() => {
          this.$refs[this.widgetId].src = this.url
        }, this.refreshPeriod * 1000)
      }
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.iframe-page {
  width: 100%;
  height: 100%;
}
</style>
